<svg
  #annoSvg
  class="anno-svg"
  [class.is-active]="active()"
  [class.is-move]="store.tool() === 'move'"
  xmlns="http://www.w3.org/2000/svg"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp()"
  (pointerleave)="onPointerUp()"
>
  <defs>
    <!-- Klein, minimalistisch pijlpunt; schaalt subtiel mee met de lijndikte. -->
    <marker
      id="hd-anno-arrowhead"
      markerWidth="4"
      markerHeight="3.2"
      refX="2.5"
      refY="1.6"
      orient="auto"
      markerUnits="strokeWidth"
    >
      <path d="M0,0 L4,1.6 L0,3.2 z" fill="context-stroke" />
    </marker>
  </defs>

  <!-- Alle annotaties leven in chart-viewBox-coördinaten; deze transform legt ze
       op de chart (en daarbuiten, over de planeetgrids). -->
  <g [attr.transform]="gTransform()">
    @for (a of annotations(); track a.id) {
      @switch (a.kind) {
        @case ('free') {
          <path
            [attr.d]="pathD(a)"
            fill="none"
            [attr.stroke]="a.color"
            [attr.stroke-width]="a.width"
            [attr.stroke-opacity]="a.opacity"
            stroke-linecap="round"
            stroke-linejoin="round"
            [class.is-selected]="a.id === store.selectedId()"
          />
        }
        @case ('arrow') {
          <line
            [attr.x1]="a.from.x"
            [attr.y1]="a.from.y"
            [attr.x2]="a.to.x"
            [attr.y2]="a.to.y"
            [attr.stroke]="a.color"
            [attr.stroke-width]="a.width"
            [attr.stroke-opacity]="a.opacity"
            stroke-linecap="butt"
            marker-end="url(#hd-anno-arrowhead)"
            [class.is-selected]="a.id === store.selectedId()"
          />
        }
        @case ('text') {
          <text
            (dblclick)="onTextDblClick(a)"
            [attr.x]="a.at.x"
            [attr.y]="a.at.y"
            [attr.fill]="a.color"
            [attr.fill-opacity]="a.opacity"
            [attr.font-size]="a.fontSize"
            dominant-baseline="text-before-edge"
            font-family="sans-serif"
            [class.is-selected]="a.id === store.selectedId()"
          >{{ a.text }}</text>
        }
      }
    }

    @if (draftPathD(); as d) {
      <path
        [attr.d]="d"
        fill="none"
        [attr.stroke]="store.color()"
        [attr.stroke-width]="store.width()"
        [attr.stroke-opacity]="store.opacity()"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    }

    @if (draftArrow(); as ar) {
      <line
        [attr.x1]="ar.from.x" [attr.y1]="ar.from.y"
        [attr.x2]="ar.to.x" [attr.y2]="ar.to.y"
        [attr.stroke]="store.color()"
        [attr.stroke-width]="store.width()"
        [attr.stroke-opacity]="store.opacity()"
        stroke-linecap="butt"
        marker-end="url(#hd-anno-arrowhead)"
      />
    }

  </g>
</svg>

<!-- Tekst-editor als gewone, absoluut-gepositioneerde HTML-input (buiten de SVG;
     foreignObject-focus is onbetrouwbaar). Positie/grootte komen van de
     chart-CTM zodat de editor verschijnt waar de tekst zal landen. -->
@if (textEdit(); as te) {
  <input
    #annoTextInput
    class="anno-text-input"
    [style.left.px]="te.left"
    [style.top.px]="te.top"
    [style.font-size.px]="te.fontPx"
    [value]="te.value"
    (input)="onTextInput($any($event.target).value)"
    (keydown.enter)="commitText()"
    (keydown.escape)="commitText()"
    (blur)="commitText()"
  />
}

@if (active()) {
  <div class="anno-toolbar-positioner">
    <div class="anno-toolbar" cdkDrag cdkDragBoundary=".chart-stack" role="toolbar" aria-label="Annotatie-gereedschap">
      <button
        eBtn
        [size]="buttonSize()"
        squared
        type="button"
        class="anno-toolbar-drag-handle"
        cdkDragHandle
        icon="grip-vertical"
        iconColor="primary-75"
        [tooltip]="'humanDesign.chart.annotationToolbar.moveTooltip' | transloco"
        [attr.aria-label]="'humanDesign.chart.annotationToolbar.moveAria' | transloco"
        (keydown)="onToolbarDragHandleKeydown($event)"
      ></button>

    <button eBtn [size]="buttonSize()" squared type="button"
      [color]="store.tool() === 'pen' ? 'primary-75' : 'highlight'"
      icon="pen" [iconColor]="store.tool() === 'pen' ? undefined : 'primary-75'"
      tooltip="Pen (P)" (click)="store.setTool('pen')"></button>

    <button eBtn [size]="buttonSize()" squared type="button"
      [color]="store.tool() === 'arrow' ? 'primary-75' : 'highlight'"
      icon="arrow-up" [iconColor]="store.tool() === 'arrow' ? undefined : 'primary-75'"
      tooltip="Pijl (A)" (click)="store.setTool('arrow')"></button>

    <button eBtn [size]="buttonSize()" squared type="button"
      [color]="store.tool() === 'text' ? 'primary-75' : 'highlight'"
      icon="font" [iconColor]="store.tool() === 'text' ? undefined : 'primary-75'"
      tooltip="Tekst (T)" (click)="store.setTool('text')"></button>

    <button eBtn [size]="buttonSize()" squared type="button"
      [color]="store.tool() === 'eraser' ? 'primary-75' : 'highlight'"
      icon="eraser" [iconColor]="store.tool() === 'eraser' ? undefined : 'primary-75'"
      tooltip="Gom (E)" (click)="store.setTool('eraser')"></button>

    <button eBtn [size]="buttonSize()" squared type="button"
      [color]="store.tool() === 'move' ? 'primary-75' : 'highlight'"
      icon="up-down-left-right" [iconColor]="store.tool() === 'move' ? undefined : 'primary-75'"
      tooltip="Verplaats (V)" (click)="store.setTool('move')"></button>

    <span class="sep"></span>

    @for (c of palette; track c) {
      <button
        type="button"
        class="swatch"
        [class.on]="store.color() === c"
        [style.background]="c"
        (click)="store.color.set(c)"
        [attr.aria-label]="'Kleur ' + c"
      ></button>
    }

    <span class="sep"></span>

    <label class="anno-range" title="Lijndikte">
      <input type="range" min="2" max="24" [value]="store.width()" (input)="store.width.set(+$any($event.target).value)" />
    </label>
    <label class="anno-range" title="Transparantie">
      <input type="range" min="0.1" max="1" step="0.1" [value]="store.opacity()" (input)="store.opacity.set(+$any($event.target).value)" />
    </label>

    <span class="sep"></span>

    <button eBtn [size]="buttonSize()" squared type="button" color="highlight"
      icon="undo" iconColor="primary-75"
      tooltip="Ongedaan maken (Ctrl+Z)" (click)="store.undo()"></button>

    <button eBtn [size]="buttonSize()" squared type="button" color="highlight"
      icon="trash" iconColor="primary-75"
      tooltip="Alles wissen (Shift+C)" (click)="store.clear()"></button>

      <button eBtn [size]="buttonSize()" squared type="button" color="highlight"
        icon="xmark" iconColor="primary-75"
        tooltip="Sluiten (Esc)" (click)="store.setTool('none')"></button>
    </div>
  </div>
}
